import * as React from 'react';
import { t } from '@citrite/translate';
import { Button, LoadingIconPrimary, RefreshIcon } from '@citrite/web-ui-component';
import { LeasesLastSyncIndicator } from 'App/ServiceContinuity/components/common/ActiveLeasesState';
import { FlexRow } from '../ui/Container';

const disabledResyncStyle = {
	pointerEvents: 'none' as 'none',
	cursor: 'default' as 'default',
	opacity: 0.5,
};

interface SyncInfoProps {
	lastSyncTime: string;
	onResync?: () => void;
	isResyncing?: boolean;
}

export const SyncInfo: React.FC<SyncInfoProps> = ({
	lastSyncTime,
	onResync,
	isResyncing = false,
}) => {
	const handleResync = () => {
		if (!isResyncing && onResync) {
			onResync();
		}
	};

	return (
		<FlexRow gap="medium">
			<LeasesLastSyncIndicator lastSyncTime={lastSyncTime} fontSize="Large" />
			{onResync && (
				<Button.IconTextButton
					style={isResyncing ? disabledResyncStyle : undefined}
					icon={isResyncing ? LoadingIconPrimary : RefreshIcon}
					size={16}
					iconPosition="left"
					text={
						isResyncing
							? t('Workspace:service_continuity.resyncing')
							: t('Workspace:service_continuity.resync')
					}
					onClick={handleResync}
					title=""
				/>
			)}
		</FlexRow>
	);
};
